/**
 * Le conseiller — `GET /api/conversations/{id}/conseil`.
 *
 * Kayla, 14-09-2026 : « un agent qui puisse connaître cette stratégie, avoir
 * le contexte […] résumer ce fan, quelle stratégie ; la suggestion de message ;
 * la suggestion de PPV avec le lien de paiement qui délivre ; la suggestion de
 * tâche quand il veut une cam, un réel, le snap ».
 *
 * Le serveur (`cyrano/conseil/conseiller.py`) lit le fil, les achats, le flow,
 * les scripts de l'équipe et les œuvres du Vault les plus proches de ce que le
 * fan vient de dire, et rend : un résumé, l'ÉTAPE de la vente de juin, la
 * stratégie, et jusqu'à trois gestes prêts. Il ne calcule qu'UNE fois par
 * message du fan (cache serveur sur le dernier entrant) : rappeler la route
 * après un de nos envois ne coûte rien.
 *
 * ⛔ Rien ne part par ici. `message` s'insère dans le composeur, `ppv` ouvre
 * la Transaction pré-remplie (prix, offre, l'œuvre à livrer, la phrase sur le
 * bouton), `tache` se lit. Le chatteur valide — « le picker pré-remplit, il
 * n'envoie pas » (20-08).
 */
import { api } from "@/core/api/client";

export type TypeDeSuggestion = "message" | "ppv" | "tache";

export interface SuggestionDuConseiller {
  type: TypeDeSuggestion;
  titre: string;
  texte: string;
  script_message_id?: string | null;
  /** Le dossier de scripts d'où vient la bulle (« Il hésite », « Au moment du
   *  lien »…) — absent quand le conseiller a écrit la phrase lui-même. */
  script_dossier?: string | null;
  content_item_id?: string | null;
  prix_eur?: number | null;
  offer_key?: string | null;
  offer_name?: string | null;
}

export interface ConseilDuChatteur {
  resume: string;
  etape?: string | null;
  strategie: string;
  suggestions: SuggestionDuConseiller[];
  message_id?: string | null;
  raison?: string | null;
}

export async function getConseil(conversationId: string): Promise<ConseilDuChatteur> {
  return api.get(`/api/conversations/${encodeURIComponent(conversationId)}/conseil`);
}

/** 23-09 : le RÉSUMÉ du fan ne se calcule plus à chaque message — il est le
 *  seul morceau qui s'ÉCRIT (un modèle), le reste est décidé sans lui. Il se
 *  demande au clic. `resume` vide + `raison` = pas de résumé. */
export interface ResumeDuFan {
  resume: string;
  raison?: string | null;
}

export async function getResumeDuFan(conversationId: string): Promise<ResumeDuFan> {
  return api.get(`/api/conversations/${encodeURIComponent(conversationId)}/conseil/resume`);
}

/** Les étapes de la vente de juin, dans les mots du chatteur — les mêmes que
 *  les dossiers de scripts de l'équipe. Une étape inconnue ne se dessine pas. */
export const ETAPES_LISIBLES: Readonly<Record<string, string>> = {
  chauffe: "Chauffer à la main",
  apres_flow: "Après le flow",
  video_qui_colle: "La vidéo qui colle à ce qu'il vient de dire",
  prix: "Proposer la vidéo et son prix",
  hesite: "Il hésite",
  lien: "Au moment du lien",
  deuxieme_marche: "La deuxième marche : vendre plus cher",
  reel: "Il veut du réel, une cam, mon snap",
  revenir: "Revenir sur le fan",
};
